import { useMemo } from "react";
import { useStores } from "../stores/useStores";
import { useSchoolFeedUrlQuery } from "./useSchoolFeedData";

export function useSchoolFeedTitle() {
  const { organizationStore, interfaceStore } = useStores();
  const urlQuery = useSchoolFeedUrlQuery();

  return useMemo(() => {
    let currentOrg = organizationStore.currentOrganization;
    let t = "Speak Your Mind. Explore New Perspectives.";
    const viewingOrganizationFeed: boolean =
      urlQuery.orgId === currentOrg.id && !urlQuery.following;
    if (viewingOrganizationFeed || currentOrg.type === "collection") {
      t = currentOrg.title;
    } else if (urlQuery.following && !organizationStore.isMyCleverFeed) {
      t = "My Feed";
    } else if (urlQuery.type === "events") {
      t = "View events from across the community.";
    }
    return t;
  }, [interfaceStore.currentFullUrl]);
}
